import { render } from "./S169331.vue?vue&type=template&id=3ff727f4"
const script = {}
script.render = render

export default script